import { Facebook, Instagram, Linkedin, Twitter, MapPin, Phone, Mail, Globe } from "lucide-react";
import { useSettings, resolveImageUrl } from "../lib/SettingsContext";

export default function Footer({ settings: settingsProp }) {
  const ctx = useSettings();
  const s = settingsProp || ctx.settings || {};
  const logoSrc = resolveImageUrl(s.logo_url) || "/logo.png";
  return (
    <footer className="bg-brand-ink text-white">
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src={logoSrc} alt="PPrints and Services" className="h-14 w-14 rounded-full object-cover bg-white" />
            <span className="font-display font-extrabold text-2xl">
              <span className="text-white">P</span><span className="text-brand-green">P</span><span className="text-white">rints</span>
              <span className="text-brand-blue"> and </span>
              <span className="text-brand-green">S</span><span className="text-white">ervices</span>
            </span>
          </div>
          <div className="mt-2 text-xs tracking-[0.05em] text-brand-green font-bold">
            We Serve You The Best
          </div>
          <p className="mt-4 text-sm text-white/70 leading-relaxed">
            Premium printing solutions in Bhopal — flex, banner, acrylic, vinyl, digital and bespoke branding for businesses that care about quality.
          </p>
          <div className="mt-5 flex gap-3">
            {[Facebook, Instagram, Linkedin, Twitter].map((Icon, i) => (
              <a
                key={i}
                href="#"
                data-testid={`footer-social-${i}`}
                className="h-9 w-9 grid place-items-center rounded-full border border-white/20 hover:bg-brand-green hover:border-brand-green transition"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <div className="overline text-brand-green">Quick Links</div>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            <li><a href="#about" className="hover:text-brand-green">About</a></li>
            <li><a href="#services" className="hover:text-brand-green">Services</a></li>
            <li><a href="#portfolio" className="hover:text-brand-green">Portfolio</a></li>
            <li><a href="#why-us" className="hover:text-brand-green">Why Us</a></li>
            <li><a href="#contact" className="hover:text-brand-green">Contact</a></li>
          </ul>
        </div>

        <div>
          <div className="overline text-brand-green">Services</div>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            <li>Flex & Banner Printing</li>
            <li>Acrylic & Glow Sign Boards</li>
            <li>Vinyl & Digital Printing</li>
            <li>Business Cards & Brochures</li>
            <li>Shop Branding</li>
          </ul>
        </div>

        <div>
          <div className="overline text-brand-green">Get in Touch</div>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            <li className="flex gap-3"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-brand-green" />{s.address}</li>
            <li className="flex gap-3"><Phone className="h-4 w-4 mt-0.5 shrink-0 text-brand-green" />{s.phone}</li>
            <li className="flex gap-3"><Mail className="h-4 w-4 mt-0.5 shrink-0 text-brand-green" />{s.email}</li>
            {s.website && (
              <li className="flex gap-3"><Globe className="h-4 w-4 mt-0.5 shrink-0 text-brand-green" />{s.website}</li>
            )}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <p>© 2026 PPrints. All Rights Reserved.</p>
          <p>Crafted with precision · Bhopal, MP</p>
        </div>
      </div>
    </footer>
  );
}
